import axios, { AxiosResponse } from 'axios';
import { parseJwt } from '../../../misc/Helpers';
import { Environment } from '../../../environment';
import { IFormData } from '../../../types/types';


// Criando a instância do Axios
const instance = axios.create({
  baseURL: Environment.URL_BASE,
});

// Interceptor de requisição para verificar a expiração do token
instance.interceptors.request.use(
    function (config) {
      const authHeader = config.headers.Authorization;
      if (typeof authHeader === 'string' && authHeader.startsWith('Bearer ')) {
        const token = authHeader.split(' ')[1];
        const data = parseJwt(token);
        if (Date.now() > data.exp * 1000) {
          window.location.href = '/login';
        }
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  

// Função para criar a autenticação Bearer
function bearerAuth(user: { accessToken: string }): string {
  return `Bearer ${user.accessToken}`;
}

// Funções do serviço
export const UsuariosServiceAPI = {
  create,
  signup,
  getById,
  getUsers,
  getRoles,
  getOrders,
  getUserMe,
  updateById,
  deleteById,
  deleteUser,
  authenticate,
};

function authenticate(username: string, password: string) {
  return instance.post('/auth/authenticate', { username, password }, {
    headers: { 'Content-type': 'application/json' },
  });
}

function getRoles(user: { accessToken: string }) {
  const url = '/role/getAll';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function signup(user: IFormData) {
  return instance.post('/auth/signup', user, {
    headers: { 'Content-type': 'application/json' },
  });
}

function create(user: { accessToken: string }, dadosValidados: IFormData) {
  console.log(dadosValidados);
  return instance.post('/auth/signup', dadosValidados, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': bearerAuth(user),
    },
  });
}

function getUsers(user: { accessToken: string }) {
  const url = '/account/getAll';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getById(user: { accessToken: string }, id: string): Promise<AxiosResponse<IFormData>> {
    console.log(id);
  const url = `/account/getById/${id}`;
  return instance.get<IFormData>(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function deleteById(user: { accessToken: string }, id: string): Promise<AxiosResponse<{ id: string }>> {
  const url = `/account/deleteById`;
  return instance.post<{ id: string }>(
    url,
    { id }, // Enviando o ID no corpo da requisição
    {
      headers: { Authorization: bearerAuth(user) },
    }
  );
}

function updateById(user: { accessToken: string }, id: string,  dados: IFormData): Promise<AxiosResponse<IFormData>> {
  const url = `/account/updateById`;
  
  return instance.post<IFormData>(
    url,
    { ...dados, id }, // Enviando o ID no corpo da requisição
    {
      headers: { Authorization: bearerAuth(user) },
    }
  );
}
/*
function updateById = async (id: number, dados: IFormData): Promise<void | Error> => {
  try {
    await instance.put(`/account/updateById${id}`, dados);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
}; */

function deleteUser(user: { accessToken: string }, username: string) {
  return instance.delete(`/api/users/${username}`, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getOrders(user: { accessToken: string }, text?: string) {
  const url = text ? `/api/orders?text=${text}` : '/api/orders';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getUserMe(user: { accessToken: string }) {
  return instance.get('/api/users/me', {
    headers: { 'Authorization': bearerAuth(user) },
  });
}
